import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { UserAuth } from './views/common_helper/userAuth';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [UserAuth],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      },
      {
        path: 'user-management',
        loadChildren: () => import('./views/user-management/user-management.module').then(m => m.UserManagementModule)
      },
      {
        path: 'app-data-management',
        loadChildren: () => import('./views/app-data-management/app-data-management.module').then(m => m.AppDataManagementModule)
      },
      {
        path: 'notification-management/push-notification',
        loadChildren: () => import('./views/notification-management/notification-management.module').then(m => m.NotificationManagementModule)
      },
      {
        path: 'workshop-management',
        loadChildren: () => import('./views/workshop-management/workshop-management.module').then(m => m.WorkshopManagementModule)
      },
      {
        path: 'flagged-management',
        loadChildren: () => import('./views/flagged-management/flagged-management.module').then(m => m.FlaggedManagementModule)
      },
      {
        path: 'media-management',
        loadChildren: () => import('./views/media-management/media-management.module').then(m => m.MediaManagementModule)
      },
      {
        path: 'conference-management',
        loadChildren: () => import('./views/conference-management/conference-management.module').then(m => m.ConferenceManagementModule)
      },
      {
        path: 'tab-management',
        loadChildren: () => import('./views/tab-management/tab-management.module').then(m => m.TabManagementModule)
      },
      {
        path: 'groups-management',
        loadChildren: () => import('./views/groups-management/groups-management.module').then(m => m.GroupsManagementModule)
      },
      {
        path: 'forum-management',
        loadChildren: () => import('./views/forum-management/forum-management.module').then(m => m.ForumManagementModule)
      },
      {
        path: 'devotion-management',
        loadChildren: () => import('./views/devotion-management/devotion-management.module').then(m => m.DevotionManagementModule)
      },
      {
        path: 'baseball-management',
        loadChildren: () => import('./views/baseball-management/baseball-management.module').then(m => m.BaseballManagementModule)
      },
      {
        path: 'resource-management',
        loadChildren: () => import('./views/resource-management/resource-management.module').then(m => m.ResourceManagementModule)
      },
      // {
      //   path: 'premium-resource-management',
      //   loadChildren: () => import('./views/premium-resource-management/premium-resource-management.module').then(m => m.PremiumResourceManagementModule)
      // },
      {
        path: 'premium-management',
        loadChildren: () => import('./views/premium-management/premium-management.module').then(m => m.PremiumManagementModule)
      },
      {
        path: 'resource-tag-management',
        loadChildren: () => import('./views/resource-tag-management/resource-tag-management.module').then(m => m.ResourceTagManagementModule)
      },
      {
        path: 'user-group-management',
        loadChildren: () => import('./views/user-group-management/user-group-management.module').then(m => m.UserGroupManagementModule)
      },
      {
        path: 'resource-type-management',
        loadChildren: () => import('./views/resource-type-management/resource-type-management.module').then(m => m.ResourceTypeManagementModule)
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('./views/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
      },
      {
        path: 'notification-management/scheduled-notifications',
        loadChildren: () => import('./views/scheduled-notifications/scheduled-notifications.module').then(m => m.ScheduledNotificationsModule)
      },
    ]
  },
  { path: '**', component: P404Component }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
